<template>
    <div id="ItemList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Part List</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="openModal()" >
                            <i class="fp-import"></i> Import
                        </a>
                        <router-link v-if="canAddCom" class="btn btn-primary" v-bind:to="{name: 'ComponentCreate'}" > <i class="fp-add"></i> Add</router-link>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content component-list">
                        <data-table-filter-config :moduleName="'componentList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'componentList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listItemTable"
                                    mode="remote"
                                    title="Parts"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: component_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <router-link title="Edit Part" v-if="canUpdateCom" class="fp-edit" v-bind:to="{name: 'ComponentEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="component_value" id="deleteItemBtn" v-on:click.prevent="ItemDelete" class="btn btn-danger">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                        <div class="modal fade part-upload-modal" id="part-upload-modal" ref="part-upload-modal" data-backdrop="static" data-keyboard="false" aria-labelledby="part-upload-modal" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Select File</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form id="importIFTAFile" class="addinspectionForm">
                                            <div class="form-row">
                                                <div class="col form-group">
                                                    <label class="control-label" for="location_ids">Location:</label>
                                                    <v-select id="location_ids" :close-on-select="true" v-model="location_ids" class="multiselect close-remove"
                                                            :show-labels="true"
                                                            :multiple="true"
                                                            :searchable="true"
                                                            :options="locationArr"
                                                            name="location_ids" placeholder="Select Location" label="text">
                                                    </v-select>
                                                    <div class="field-error">{{location_error_msg}}</div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col form-group">
                                                    <label class="control-label require mb-2" for="name">File:</label><br/>
                                                    <input id="partUploadFile" type="file" @change="onFileChanged">
                                                    <div class="field-error">{{import_error}}</div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col form-group" v-if="fileName != ''">
                                                    <label class="control-label"> Download Sample file </label>
                                                    <a href="javascript:void(0)" v-on:click="downloadSample()"> <i class="fp-text-document"></i> {{fileName}} </a>
                                                </div>
                                            </div>

                                            <p v-if="importedCount > 0"><i class="fa fa-check" aria-hidden="true"></i> &nbsp;<strong>{{importedCount}} Records imported</strong></p> 

                                            <template v-if="duplicatePart.part != undefined">
                                                <ul>
                                                    <li v-for="(item, key) in duplicatePart.part" :key="key">
                                                        <p><strong>{{ key }} </strong> Part Not Imported</p>
                                                        <ul>
                                                        <li v-for="(value, prop) in item" :key="prop">
                                                            <template v-if="value == ''">
                                                                <span v-if="prop == 'part_number'">Part Number Is Blank</span> 
                                                                <span v-if="prop == 'category_code'">Category Is Blank</span>                                                                
                                                            </template>
                                                            <template v-else> 
                                                                <span v-if="prop == 'part_number'">Part Number {{ value }} Already Exists</span>
                                                                <span v-if="prop == 'category_code'">Category Code {{ value }} Not Available</span>
                                                                <span v-if="prop == 'stock_unit_code'">Stock Unit {{ value }} Not Available</span>
                                                                <span v-if="prop == 'purchase_unit_code'">Purchase Unit {{ value }} Not Available</span>
                                                                <span v-if="prop == 'mfg_code'">Mfg Code {{ value }} Not Available</span>
                                                                <span v-if="prop == 'vmrs_code'">VMRS Code {{ value }} Not Available</span>
                                                            </template>
                                                        </li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </template>
                                        </form>

                                        <div class="modal-footer">
                                            <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                                            <button class="btn btn-primary" id="importButton" v-on:click="importParts()"> <i class="fp-import"> </i> Import</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";


import EventBus from "././event-bus";


import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "ItemList",
        metaInfo() {
            return {title: "Part List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,contractMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    hidden:false,
                    sortable: false,
                },
                {
                    label: 'Part Number',
                    field: 'code',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // {
                //     label: 'Stock Part Number',
                //     field: 'stock_part_number',
                //     filterable: true,
                //     hidden:false,
                //     fpFieldType:"text",
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "stock_part_number", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                // {
                //     label: 'Name',
                //     field: 'name',
                //     filterable: true,
                //     fpFieldType:"text",
                //     hidden:false,
                //     filterOptions: {
                //         enabled: false, // enable filter for this column
                //         placeholder: "Name", // placeholder for filter input
                //         filterValue: '', // initial populated value for this filter
                //         trigger: "enter" //only trigger on enter not on keyup
                //     }
                // },
                {
                    label: 'Vendor Item No',
                    field: 'vendor_item_number',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Vendor Item No", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Category',
                    field: 'category',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Category", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Vendor',
                    field: 'vendor',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Vendor", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
              /*  {
                    label: 'Depreciable',
                    field: 'depriciable',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Select Depreciable", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['YES', 'NO'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },*/
                {
                    label: 'Manufacturer',
                    field: 'manufacturer',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Manufacturer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Is Non Inventory Item',
                    field: 'is_non_inv_item',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Is Non Inventory Item", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['YES','NO'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Created At',
                    field: 'created_at',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            component_value: false,
            loading:false,
            canUpdateCom:false,
            canAddCom:false,
            pageKey:"_item_list_",
            locationArr: [],
            location_ids: [],
            location_error_msg: "",
            duplicatePart:[],
            importedCount:0,
            import_error:'',
            fileName:'',
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_component') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_component') {
                            self.component_value = true;
                        }
                        if (permissions[i].name == 'add_component') {
                            self.canAddCom = true;
                            self.canUpdateCom = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listItemTable.unselectAllInternal();
            },

            /*updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadList();
            },
            onPerPageChange(params) {
                this.serverParams.page=1;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadList();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('name');
                    field:('is_default');
                    field:('depriciable');
                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.name || filters.is_default || filters.depriciable) {
                    this.loadList();
                }
            },*/
            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/
            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    // exportFiltered: self.exportFilteredFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/component/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'component-list')
                    }
                });
            },
            ItemDelete() {
              var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Part?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      var data = this.$refs['listItemTable'].selectedRows;
                      var use = [];
                      for (var i = 0; i < data.length; i++) {
                          use.push(this.$refs['listItemTable'].selectedRows[i].id)
                      }
                      console.log("list of IDS =", use);
                      self.loading = true;
                      $("#deleteItemBtn").val("Deleting ...");
                      $.ajax({
                        url: process.env.ROOT_API + "/component/delete",
                        type: "POST",
                        data: 'id=' + use,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                            $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);
                            setTimeout(function () {
                                $("#deleteItemBtn").val("Delete");
                            }, 10000);
                            self.rows = data.content.row;
                            if (data.code == '200') {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'component-delete')
                        }
                    });

                    } else {
                      console.log("no");
                    }
                });
                // if (confirm('Are you sure that you want to delete this Component?')) {
                // }
            },
            openModal: function(){
                let self = this;
                self.locationArr = [];
                self.location_ids = [];
                self.location_error_msg = "";
                self.duplicatePart = [];
                self.importedCount = 0;
                self.selectedPO = "";
                self.selectedFile = "";
                $("#partUploadFile").val('');
                self.import_error = '';
                self.getLocations();
                self.generateExcelSample();
                $('#part-upload-modal').modal('show');
            },
            onFileChanged(event) {
                const file = event.target.files[0];
                let self = this;
                self.selectedFile = file;
                self.import_error = '';
            },
            getLocations() {
                this.loadFieldData(['location']);
            },
            generateExcelSample() {
                let self = this;
                $.ajax({
                    url:
                    process.env.ROOT_API + "/component-excel/generate",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,
                    success: function(data) {
                        self.loading = false;
                        self.fileName = data.content.file;
                        self.file = data.content.web;

                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'part-upload-generate')

                    }
                });
            },
            downloadSample(){
                let self = this;
                let docPath = self.file;
                let save = document.createElement('a');
                save.href = docPath;
                save.download = docPath;
                save.target = '_blank';
                document.body.appendChild(save);
                save.click();
                document.body.removeChild(save);
            },
            importParts() {
                let self = this;
                self.import_error = "";
                
                if( self.selectedFile == "" || self.selectedFile == null){
                    self.import_error = "Please Select Excel File.";
                    return;
                }
                let fileExtension = ['xls', 'xlsx'];
                if ($.inArray(self.selectedFile.name.split('.').pop().toLowerCase(), fileExtension) == -1) {
                    self.import_error = "Only formats are allowed : "+fileExtension.join(', ');
                    return;
                }

                let formData = new FormData();
                formData.append('myFile', self.selectedFile);
                formData.append('location_ids', JSON.stringify(self.location_ids));

                self.loading = true;
                $('#importButton').text('Fetching...');
                $('#importButton').prop('disabled',true);
                $('#cancelButton').prop('disabled',true);

                $.ajax({
                    url: process.env.ROOT_API + "/component-excel/import",
                    type: "POST",
                    data: formData,
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.import_error = '';
                        if (data.code == 400) {
                            self.import_error = data.message;
                            return;
                        }
                        if (data.status == "success") {

                            if ( Object.keys(data.duplicate).length > 0){

                                self.duplicatePart = data.duplicate;
                                self.importedCount = data.content;

                            }else{
                                if(data.content != false){
                                    self.$swal('',data.content+" Records imported",'success');
                                }
                                $('#part-upload-modal').modal('hide');
                                self.loadList();
                            }

                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.generateStatusCodeMessage(jqXHR,true,'part-upload-import-error')
                    }
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/ComponentList.vue